import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowAvatarGroup: Components<Theme>['MuiAvatarGroup'] = {
  defaultProps: {
    role: 'group',
  },
  styleOverrides: {
    avatar: {
      // automatically adds border to improve accessibility
      border: '1px solid currentColor',
      boxSizing: 'border-box',
    },
  },
};
